import { type GetServerSideProps } from "next";
import Link from "next/link";
import { Layout } from "~/components/Layout/Layout";
import { LibraryLocation } from "~/components/LibraryLocation";
import { EventNames } from "~/mixpanel/EventNames";
import { trackEvent } from "~/mixpanel/trackEvent";

const Contact = () => (
  <Layout
    title="Contact us"
    description="Get in touch!"
    imgUrl="/img/contact-us.jpg"
  >
    <p>
      If you would like to get in contact with us, you may contact us using any
      of the means below:
      <p className="font-bold">Email us</p>
      <Link target="_blank" href="mailto:admin@iplnj.com">
        admin@iplnj.com
      </Link>
      <p className="font-bold">Call us</p>
      <Link target="_blank" href="tel:1-973-400-0059">
        1-973-400-0059
      </Link>
      <p className="font-bold">Visit us</p>
      <LibraryLocation />
    </p>
  </Layout>
);

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  await trackEvent(ctx, EventNames.CONTACT_PAGE_VIEWED);
  return { props: {} };
};

export default Contact;
